import * as React from 'react'

function IconLoading({
  color,
  width,
  height,
}: {
  color?: string
  width?: number
  height?: number
}) {
  return (
    <svg
      width={width || 75}
      height={height || 75}
      viewBox="0 0 75 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.351 49.813c6.689 12.079 21.903 16.448 33.982 9.76 12.078-6.69 16.448-21.904 9.759-33.982-6.689-12.079-21.903-16.448-33.982-9.76"
        stroke={color || '#FFF'}
        strokeOpacity={0.5}
        strokeWidth={12}
        strokeLinecap="round"
      />
      <path
        d="M30.406 13.417C17.07 16.99 9.155 30.699 12.728 44.035c3.574 13.337 17.282 21.252 30.619 17.678 13.337-3.574 21.251-17.282 17.678-30.619"
        stroke={color || '#FFF'}
        strokeWidth={12}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconLoading
